import { LdapPouzivatelItem } from 'ciselniky-frontend-ts-axios';

export default function convertOrganizaciaPredkladatelListMapToMap(
  organizaciaPredkladatelListMap: { [organizaciaUuid: string]: Array<LdapPouzivatelItem> },
): Map<string, Array<{ uuid: string, nazov: string }>> {
  const map = new Map<string, Array<{ uuid: string, nazov: string }>>();

  Object.keys(organizaciaPredkladatelListMap).forEach((key) => {
    const ldapUserList = organizaciaPredkladatelListMap[key];
    map.set(key, ldapUserList.map(ldapUser => ({ uuid: ldapUser.uuid, nazov: ldapUser.nazov })));
  });

  return map;
}
